import { Component, AfterViewInit, Input, OnDestroy, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { DynamicBaseForm } from './models/dynamic-base-form';

import { Subscription } from 'rxjs';


@Component({
    selector: 'dynamic-form-control',
    templateUrl: './dynamic-form-control.component.html'
})
export class DynamicFormControlComponent implements OnDestroy, OnInit, AfterViewInit {
    @Input() controlForm!: DynamicBaseForm<string>;
    @Input() form!: FormGroup;
    @Input() browserLang!: string;

    subcriptions: Subscription[] = [];

    constructor() { }

    ngOnInit() { }

    ngAfterViewInit() {  }

    get isValid() { 
        return this.form.controls[this.controlForm.key].valid; 
    }

    ngOnDestroy(): void {
        this.subcriptions.forEach((s) => {
            s.unsubscribe();
        });
    }
}